import { createElement } from 'react';

import SuccessIcon from '@crm/shared/assets/icons/circle-check.svg?react';
import InputErrorIcon from '@crm/shared/assets/icons/input-error.svg?react';
import { tw } from '@crm/shared/lib';

export const toastStyles = {
    success: {
        style: tw('text-xs text-foreground'),
        icon: createElement(SuccessIcon),
    },
    error: {
        style: tw('text-xs text-foreground'),
        icon: createElement(InputErrorIcon),
    },
};
